export default __webpack_public_path__ + "static/media/arras08.38c480c2.jpg";